import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (e, tab) => {
    e.preventDefault();
    if (tab) {
      navigate(`/?tab=${tab}`);
    } else {
      navigate('/');
    }
  };

  return (
    <footer className="footer-outer blue-trust-background">
      <div className="container footer-inner">
        <div className="footer-three-grid wow fadeIn animated" data-wow-delay="0.66s">
          <div className="column-1-3">
            <h1 className="footer-text">Tripletex playbook</h1>
          </div>
          <div className="column-2-3">
            <nav className="footer-nav">

              <ul className="footer-text">
                <li><a href="/" onClick={(e) => handleNavClick(e)}>Home</a></li>
                <li><a href="/?tab=principles" onClick={(e) => handleNavClick(e, 'principles')}>Core principles</a></li>
                <li><a href="/?tab=team" onClick={(e) => handleNavClick(e, 'team')}>Core team</a></li>
                <li><a href="/?tab=workflow" onClick={(e) => handleNavClick(e, 'workflow')}>Core workflow</a></li>
              </ul>

            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
